var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 13.887c-.907-4.6-4.947-8.054-9.8-8.054a9.994 9.994 0 0 0-8.867 5.387A7.992 7.992 0 0 0 .5 19.167c0 4.413 3.587 8 8 8h17.333A6.67 6.67 0 0 0 32.5 20.5c0-3.52-2.733-6.373-6.2-6.613ZM25.833 24.5H8.5a5.332 5.332 0 0 1-5.333-5.333c0-2.734 2.04-5.014 4.746-5.294l1.427-.146.667-1.267A7.291 7.291 0 0 1 16.5 8.5a7.337 7.337 0 0 1 7.187 5.907l.4 2 2.04.146a3.973 3.973 0 0 1 3.706 3.947c0 2.2-1.8 4-4 4Zm-14.666-6.667h3.4v4h3.866v-4h3.4L16.5 12.5l-5.333 5.333Z",
    fill: "#1F2428"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.f2acafe5a2818c77933c11715bebd690.svg";
export { ForwardRef as ReactComponent };